"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyZone = void 0;
var BodyZone;
(function (BodyZone) {
    BodyZone["Upper"] = "upper";
    BodyZone["Lower"] = "lower";
    BodyZone["Abdominal"] = "abdominal";
})(BodyZone = exports.BodyZone || (exports.BodyZone = {}));
//# sourceMappingURL=body-zone.enum.js.map